import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { ServiceIncludedComponent } from './service-included.component';



@NgModule({
  declarations: [ServiceIncludedComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, PipesModule,
  ],
  exports: [ServiceIncludedComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class ServiceIncludedModule { }
